// extracted by mini-css-extract-plugin
export default {"articleBlank":"article_blank_articleBlank__EVZYv","blocksContainer":"article_blank_blocksContainer__R4sGG","blockWrapper":"article_blank_blockWrapper__Yrocu"};